import type { ComponentProps } from 'react';
import { AvatarBase } from '@/components/Avatar/base';
import Icon from '@/components/Icon/Icon';
import type { DeviceGenre } from '@/constants/device';
import { useDeviceGenre } from '../../genre/useDeviceGenre';
type Props = {
  genre: DeviceGenre;
} & Omit<ComponentProps<typeof AvatarBase>, 'alt' | 'fallback' | 'shape' | 'variant'>;

/**
 * デバイスのアバターを表示するコンポーネントです。
 * genreに応じてフォールバックとして表示されるアイコンが変わります。
 */
export function AvatarDevice(props: Props) {
  const {
    icon
  } = useDeviceGenre();
  const {
    genre
  } = props;
  return <AvatarBase {...props} shape="square" alt={genre} // デバイスのジャンルをaltに指定。アイコンは表示されるはず
  fallback={<Icon iconName={icon(genre)} />} />;
}